import React from "react";
import { Spinner } from "../../loaders/Spinner";
import { Page } from "../Page";

export const PageLoader = () => {
    return (
        <Page>
            <Spinner size="large" color="primary" />
        </Page>
    );
};
